import { render, staticRenderFns } from "./IconCloseButton.vue?vue&type=template&id=7a50aa41&scoped=true&lang=pug&"
import script from "./IconCloseButton.vue?vue&type=script&lang=ts&"
export * from "./IconCloseButton.vue?vue&type=script&lang=ts&"
import style0 from "./IconCloseButton.vue?vue&type=style&index=0&id=7a50aa41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a50aa41",
  null
  
)

export default component.exports